var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("PermissionSimplePage", {
        attrs: { permission: _vm.hasPermissionEx("view") }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.hasPermissionEx("view"),
              expression: "hasPermissionEx('view')"
            }
          ],
          staticClass: "main-body"
        },
        [
          _c(
            "div",
            { staticClass: "main-dialog" },
            [
              _c("div", { attrs: { id: "prop-card-container" } }, [
                _c("div", { staticClass: "prop-input-form" }, [
                  _c("div", { staticClass: "prop-card-design" }, [
                    _c("div", [
                      _c("span", { staticClass: "text" }, [
                        _vm._v(
                          _vm._s(_vm.$t("channel.smsChannelGroupNameText"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "text" }, [
                        _vm._v(_vm._s(_vm.channelGroupName))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "prop-card-design" }, [
                    _c("span", { staticClass: "text" }, [
                      _vm._v(_vm._s(_vm.$t("system.user.query")))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "all-forms" }, [
                      _c(
                        "div",
                        { staticClass: "form" },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("channel.organizationNameText")) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("SMS.pleaseChoose"),
                                clearable: "",
                                filterable: ""
                              },
                              model: {
                                value: _vm.queryParameter.orgCode,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "orgCode", $$v)
                                },
                                expression: "queryParameter.orgCode"
                              }
                            },
                            _vm._l(this.organizationNameOption, function(item) {
                              return _c("el-option", {
                                key: item.organizationCode,
                                attrs: {
                                  label: item.organizationName,
                                  value: item.organizationCode
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form" },
                        [
                          _c("div", { staticClass: "label" }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$t("SMS.agentNameText")) +
                                "\n                  "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "filter-item",
                              attrs: {
                                placeholder: _vm.$t("SMS.pleaseChoose"),
                                clearable: "",
                                filterable: ""
                              },
                              model: {
                                value: _vm.queryParameter.agentId,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryParameter, "agentId", $$v)
                                },
                                expression: "queryParameter.agentId"
                              }
                            },
                            _vm._l(_vm.agentList, function(item) {
                              return _c("el-option", {
                                key: item.agentId,
                                attrs: {
                                  label: item.agentName,
                                  value: item.agentId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "searchButton" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "filter-item",
                            attrs: {
                              plain: _vm.$store.getters.plainConf,
                              type: "info",
                              icon: "el-icon-search"
                            },
                            on: { click: _vm.handleFilter }
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(_vm.$t("common.search")) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "actions" }, [
                _c("div", { staticClass: "otherActions" }),
                _vm._v(" "),
                _c("div", { staticClass: "addEditOrDelete" }, [
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("add"),
                              expression: "hasPermissionEx('add')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "success",
                            icon: "el-icon-plus"
                          },
                          on: {
                            click: function($event) {
                              _vm.addDialogVisible = true
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.add")) +
                              "\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.hasPermissionEx("delete"),
                              expression: "hasPermissionEx('delete')"
                            }
                          ],
                          staticClass: "filter-item",
                          attrs: {
                            plain: _vm.$store.getters.plainConf,
                            type: "danger",
                            icon: "el-icon-delete"
                          },
                          on: { click: _vm.handleBatchDelete }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.$t("common.batchDeleteText")) +
                              "\n              "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.hasPermissionEx("view"),
                      expression: "hasPermissionEx('view')"
                    }
                  ],
                  key: _vm.tableKey,
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.list,
                    stripe: _vm.$store.getters.stripeConf,
                    border: _vm.$store.getters.borderConf
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: { type: "selection", width: "55" }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("SMS.agentNameText"),
                      align: "center",
                      "min-width": "130"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  content: _vm.convertAgentName(
                                    scope.row.agentId
                                  )
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ellipsis",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.convertAgentName(
                                            scope.row.agentId
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("channel.organizationNameText"),
                      align: "center",
                      "min-width": "130"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  content: _vm.convertOrganizationCode(
                                    scope.row.orgCode
                                  )
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ellipsis",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm.convertOrganizationCode(
                                            scope.row.orgCode
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("channel.remarkText"),
                      align: "center",
                      "min-width": _vm.customTableColumnWidth("md") || 130
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  content: scope.row.remark
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ellipsis",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(scope.row.remark) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("channel.creatorText"),
                      align: "center",
                      "min-width": _vm.customTableColumnWidth("md") || 130
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  content: scope.row.createUserName
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ellipsis",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(scope.row.createUserName) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("common.createTime"),
                      align: "center",
                      "min-width": _vm.customTableColumnWidth("md") || 130
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-popover",
                              {
                                attrs: {
                                  trigger: "click",
                                  content: scope.row.createTime
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "ellipsis",
                                    attrs: { slot: "reference" },
                                    slot: "reference"
                                  },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(scope.row.createTime) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("common.operationText"),
                      align: "center",
                      "min-width": "240"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.hasPermissionEx("delete"),
                                    expression: "hasPermissionEx('delete')"
                                  }
                                ],
                                staticClass: "filter-item",
                                attrs: {
                                  plain: _vm.$store.getters.plainConf,
                                  round: _vm.$store.getters.roundConf,
                                  size: "mini",
                                  type: "danger",
                                  icon: "el-icon-delete"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.handleDelete(scope.row)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("common.delete")) +
                                    "\n              "
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasPermissionEx("view"),
                    expression: "hasPermissionEx('view')"
                  }
                ],
                attrs: {
                  total: _vm.total,
                  page: _vm.queryParameter.pageNum,
                  limit: _vm.queryParameter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.queryParameter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.queryParameter, "pageSize", $event)
                  },
                  pagination: _vm.getList
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog" },
                [
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        id: "dialog",
                        visible: _vm.addDialogVisible,
                        width: "700px",
                        "close-on-click-modal": false
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.addDialogVisible = $event
                        },
                        close: _vm.handleResetAdd
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "card" },
                        [
                          _c("div", { staticClass: "card-title" }, [
                            _c("div", { staticClass: "title" }, [
                              !_vm.updateChannelFlag
                                ? _c("span", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(_vm.$t("channel.addGroupText")) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm.updateChannelFlag
                                ? _c("span", [
                                    _vm._v(
                                      "\n                      " +
                                        _vm._s(
                                          _vm.$t("channel.updateGroupText")
                                        ) +
                                        "\n                    "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "close" }, [
                              _c("i", {
                                staticClass: "el-icon-close",
                                on: { click: _vm.handleResetAdd }
                              })
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-form",
                            {
                              ref: "addInformation",
                              attrs: {
                                model: _vm.addInformationParameter,
                                rules: _vm.rules,
                                "label-width": "220px"
                              }
                            },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "channel.smsChannelGroupNameText"
                                    )
                                  }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      disabled: "",
                                      placeholder: _vm.$t(
                                        "common.pleaseEnterText"
                                      ),
                                      filterable: ""
                                    },
                                    model: {
                                      value:
                                        _vm.addInformationParameter
                                          .channelGroupName,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addInformationParameter,
                                          "channelGroupName",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addInformationParameter.channelGroupName"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: _vm.$t(
                                      "channel.organizationNameText"
                                    ),
                                    prop: "organizationCodes"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "filter-item",
                                      attrs: {
                                        placeholder: _vm.$t("SMS.pleaseChoose"),
                                        clearable: "",
                                        multiple: "",
                                        filterable: "",
                                        disabled:
                                          _vm.addInformationParameter.agentIds
                                            .length > 0
                                      },
                                      model: {
                                        value:
                                          _vm.addInformationParameter
                                            .organizationCodes,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.addInformationParameter,
                                            "organizationCodes",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "addInformationParameter.organizationCodes"
                                      }
                                    },
                                    _vm._l(
                                      this.organizationNameOption,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.organizationCode,
                                          attrs: {
                                            label: item.organizationName,
                                            value: item.organizationCode
                                          }
                                        })
                                      }
                                    ),
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-form-item",
                                {
                                  attrs: { label: _vm.$t("common.remarkText") }
                                },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      clearable: "",
                                      placeholder: _vm.$t(
                                        "common.pleaseEnterText"
                                      ),
                                      filterable: ""
                                    },
                                    model: {
                                      value: _vm.addInformationParameter.remark,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.addInformationParameter,
                                          "remark",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "addInformationParameter.remark"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "confirm-button" },
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.handleReset } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.reset")) +
                                      "\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleAddNoted }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("common.submit")) +
                                      "\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dialog",
                    {
                      attrs: {
                        id: "addNotedDialog",
                        visible: _vm.addNotedDialogVisible,
                        width: "700px"
                      },
                      on: {
                        "update:visible": function($event) {
                          _vm.addNotedDialogVisible = $event
                        },
                        close: function($event) {
                          _vm.addNotedDialogVisible = false
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "content" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.remarkMessage) +
                              "\n              "
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "confirm-button" },
                          [
                            _c(
                              "el-button",
                              {
                                on: {
                                  click: function($event) {
                                    _vm.addNotedDialogVisible = false
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("common.cancel")) +
                                    "\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.handleAddCostMember }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("common.confirm")) +
                                    "\n                "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }